import { useEffect } from 'react'

export const useFocusFirstElement = (
  containerRef: React.RefObject<HTMLElement | undefined | null>
) => {
  useEffect(() => {
    if (!containerRef?.current) return

    const focusableSelectors = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ]

    const firstFocusable = containerRef?.current.querySelector<HTMLElement>(
      focusableSelectors.join(', ')
    )
    firstFocusable?.focus()
  }, [containerRef])
}
